/*
*
* JS Imports
*
* */
import CartDrawer from "./core/components/cart-drawer";
import ProductForms from "./core/services/product-forms";
import QuantityComponents from "./core/services/quantity-components";
import CartCount from "./core/components/cart-count";
import Nav from "./app/nav";
import CartService from "./core/services/cart";
import AddToCartButton from "./core/components/add-to-cart-button";
import AddToCartButtons from "./core/services/add-to-cart-buttons";
import Carts from "./core/services/carts";
// import Swiper, { Navigation, Pagination } from './../../node_modules/swiper'
import SwiperGuitar from "./app/swiper-guitar";
import SwiperAccessories from "./app/swiper-accessories";
import SwiperTestimonials from "./app/swiper-testimonials";
import SwiperArtists from "./app/swiper-artists";
import SwiperGallery from "./app/swiper-gallery";
import SwiperBlocks from "./app/swiper-blocks";
import SwiperSwatches from "./app/swiper-swatches";
import SwiperProcess from "./app/swiper-process";
import SwiperBasic from "./app/swiper-basic";
import ArticlesFilter from "./app/articles";
import FaqsFilter from "./app/faqs";
import CollectionFilter from "./app/products";
import Variant from "./app/variant";
import Animation from "./app/animation";
import Contact from "./app/contact";
import VideoModal from "./app/video-modal";
import AccountSignup from "./app/account-signup";
import InitZoomables from "./app/zoomable-init";
import KlaviyoSignup from "./app/klaviyo-signup";

import { Collapse, Modal } from "bootstrap";





/** Initialize All Add to cart forms  */

Shopify.cartService = CartService();
ProductForms('[sh-product-form]')
QuantityComponents('[sh-quantity-component]')
CartDrawer('[sh-cart-drawer]', '[sh-cart-drawer-trigger]', { openOnAdd: true })
CartCount('[sh-cart-count]');
AddToCartButtons('[sh-add-to-cart]')
Carts('[sh-cart-wrapper]');
Nav();
SwiperGuitar();
SwiperAccessories();
SwiperTestimonials();
SwiperArtists();
SwiperGallery();
SwiperBasic();
ArticlesFilter();
FaqsFilter();
CollectionFilter();
Variant();
SwiperBlocks();
SwiperSwatches();
SwiperProcess();
Animation();
Contact();
VideoModal();
AccountSignup();
KlaviyoSignup();

window.addEventListener('load', () => {
  InitZoomables();
})

